import axios from 'axios';
import get from 'lodash/get';
import { getJwtToken } from '../../services/auth';
import { Amplify } from '@aws-amplify/core';
import config from '../../config';

Amplify.configure(config);

/** Deployed dev, staging, and prod bundles all use this gateway. */
const DEFAULT_NDT_API = 'https://3eal5enxo5.execute-api.us-west-2.amazonaws.com/';

export const ndtApiBaseUrl = (
  process.env.REACT_APP_NDT_DASHBOARD_API_URL || DEFAULT_NDT_API
).replace(/\/?$/, '/');

const axiosConfig = axios.create({
  baseURL: ndtApiBaseUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: getJwtToken(),
  },
});

const handleErroredResponse = async (error) => {
  const originalRequest = get(error, ['response', 'config'], undefined);
  const statusCode = get(error, ['response', 'status'], undefined);
  const errMessage = get(error, ['response', 'data', 'name'], undefined);
  const errData = get(error, ['response', 'data'], undefined);

  if (statusCode === 401) {
    if (errMessage === 'TokenExpiredError') {
      const token = await getJwtToken();
      if (token) {
        axios.defaults.headers.common['Authorization'] = token;
      }
      return axiosConfig(originalRequest);
    }
  }

  if (errData) {
    return Promise.reject(errData);
  }
  return Promise.reject(error.message);
};

axiosConfig.interceptors.request.use(async (config) => {
  const aConfig = config;
  const authToken = await getJwtToken();
  if (authToken) {
    aConfig.headers["Authorization"] = authToken;
  }
  return aConfig;
}, error => Promise.reject(error));

axiosConfig.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return await handleErroredResponse(error);
  }
);

export default axiosConfig;

